import request from '@/modules/base/util/request'
import config from 'config'
import { groupBy } from 'lodash'

// actions
const SHOW_SEARCH_LOADER = 'SHOW_SEARCH_LOADER'
const HIDE_SEARCH_LOADER = 'HIDE_SEARCH_LOADER'
const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
const FINSIHED_FETCHING_SEARCH_RESULTS = 'FINSIHED_FETCHING_SEARCH_RESULTS'
const ERROR_FETCHING_SEARCH_RESULTS = 'ERROR_FETCHING_SEARCH_RESULTS'

// reducer
const initialState = {
  isLoading: true,
  searchResults: {},
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SEARCH_LOADER:
      return { ...state, isLoading: true }

    case HIDE_SEARCH_LOADER:
      return { ...state, isLoading: false }

    case SET_SEARCH_RESULTS:
      const { searchResults } = action
      return { ...state, searchResults }

    case FINSIHED_FETCHING_SEARCH_RESULTS:
      const { results } = action

      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        searchResults: results,
      })

    case ERROR_FETCHING_SEARCH_RESULTS:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_SEARCH_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_SEARCH_LOADER,
  }
}

const finishedFetchingSearchResults = (results) => {
  return {
    type: FINSIHED_FETCHING_SEARCH_RESULTS,
    results,
  }
}

const errorFetchingSearchResults = (error) => {
  return {
    type: ERROR_FETCHING_SEARCH_RESULTS,
    error,
  }
}

export const resetSearch = () => {
  return (dispatch) => {
    dispatch(finishedFetchingSearchResults({}))
  }
}

export const fetchSearchResults = (searchTerm) => {
  return (dispatch) => {
    if (searchTerm.length >= 2) {
      dispatch(showLoader())
      request(`${config.resourceHost}search`, { auth: true, isConcurrent: true, data: { search: searchTerm } })
        .then(({ body: { data } }) => {
          dispatch(finishedFetchingSearchResults(groupBy(data, 'type')))
        })
        .catch((error) => {
          dispatch(errorFetchingSearchResults(error))
        })
    } else {
      dispatch(finishedFetchingSearchResults({}))
    }
  }
}
